module.exports = __webpack_public_path__ + "media/v2/person-8092128c.png";